<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Alcances"
          :icon="'grid'"
        />
      </div>
    </div>

    <div class="row tree">
      <div class="col-12">
        <ul>
          <scope-tree
            :node="$store.state.evaluatorReview.scope.tree"
            @add-child="openAddModal"
            @remove-child="openDeleteModal"
            @edit-child="openEditModal"
          ></scope-tree>
        </ul>
      </div>
    </div>

    <scope-modal
      v-if="isAddEditModalActive"
      modalTitle="Añadir Nodo"
      editModalTitle="Editar Nodo"
      :inputs="$store.state.evaluatorReview.scope.tree.node"
      @close-modal="closeAddEditModal"
    />

    <dashboard-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiURL";

export default {
  extends: CoreLibrary,
  data() {
    return {
      node: {},
      sourceNode: {},
      isAddEditModalActive: false,
      deleteLoader: false,
      deleteConfirmationModalActive: false,
    };
  },
  created() {
    this.data();
  },
  methods: {
    data() {
      this.$store.dispatch("getAccAppOptions");
      this.$store.dispatch("getScopeTree");
    },

    openAddModal(node) {
      this.$store.state.evaluatorReview.scope.tree.sourceNode = node;
      this.$store.state.evaluatorReview.scope.tree.node = {
        id: null,
        parent_id: node.id,
        accreditation_area_id: node.accreditation_area_id,
        accreditation_activity_id: node.accreditation_activity_id,
        value: "",
      };
      this.isAddEditModalActive = true;
    },

    openEditModal(node) {
      this.$store.state.evaluatorReview.scope.tree.sourceNode = node;
      this.$store.state.evaluatorReview.scope.tree.node = {
        id: node.id,
        parent_id: node.parent_id,
        accreditation_area_id: node.accreditation_area_id,
        accreditation_activity_id: node.accreditation_activity_id,
        value: node.value,
      };
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#modal-add-edit").modal("hide");
      this.isAddEditModalActive = false;
    },

    openDeleteModal(node) {
      this.$store.state.evaluatorReview.scope.tree.sourceNode = node;
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `${actions.SCOPES}/${this.$store.state.evaluatorReview.scope.tree.sourceNode.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((res) => {
          if (res.status == 200) {
            this.$store.dispatch("getScopeTree");
            this.deleteLoader = false;
            $("#modal-delete").modal("hide");
            this.cancelled();
            this.$toastr.s(this.$t("deleted_success"));
          }
        })
        .catch(({ error }) => {});
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
  },
};
</script>

<style>
.tree ul {
  list-style: none;
}

.tree li {
  margin-top: 1em;
}
</style>